import jsPDF from 'jspdf';

// Generate A4 PDF letterhead with real QR-code styled block
export async function generateLetterheadPDF(data, filename) {
  const {
    name = '', designation = '', department = '', address = 'TSE Workspace Office, Green City, Sector-10, Lucknow - 226010',
    phone = '+91 98765 43210', email = '', website = 'www.tseworkspace.com',
    refNo = 'TSE/LET/2025-26/XXX', date = new Date().toLocaleDateString('en-IN'),
    template = 'Modern',
  } = data;

  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const W = 210, H = 297;

  // ── HEADER ──────────────────────────────────────────────────────────────────
  // Gradient header background (simulate with rects)
  doc.setFillColor(26, 82, 118);
  doc.rect(0, 0, W, 38, 'F');
  doc.setFillColor(30, 132, 73);
  doc.rect(W * 0.55, 0, W * 0.45, 38, 'F');
  doc.setFillColor(26, 82, 118, 0.85);
  // Overlay blend strip
  doc.setGState(doc.GState({ opacity: 0.7 }));
  doc.setFillColor(30, 100, 100);
  doc.triangle(W * 0.4, 0, W * 0.7, 0, W * 0.55, 38, 'F');
  doc.setGState(doc.GState({ opacity: 1 }));

  // Logo circle
  doc.setFillColor(255, 255, 255, 0.2);
  doc.setDrawColor(255, 255, 255);
  doc.setLineWidth(0.5);
  doc.circle(20, 19, 9, 'D');
  // Tree icon inside circle (draw simple tree)
  doc.setFillColor(255, 255, 255);
  doc.setFontSize(10);
  doc.setTextColor(255, 255, 255);
  doc.text('TSE', 16, 20.5);

  // Org name
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('TSE ENVIRONMENT', 34, 16);
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(220, 240, 255);
  doc.text(`Official Letterhead  —  ${template} Template`, 34, 22);

  // Ref box (right side)
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('Ref No.:', W - 55, 14);
  doc.text('Date:', W - 55, 20);
  doc.setFont('helvetica', 'normal');
  doc.text(refNo, W - 38, 14);
  doc.text(typeof date === 'string' ? date : new Date(date).toLocaleDateString('en-IN'), W - 38, 20);

  // ── QR CODE BLOCK (top-right of body) ──────────────────────────────────────
  const qrX = W - 34, qrY = 44, qrSize = 24;
  doc.setDrawColor(26, 82, 118);
  doc.setLineWidth(0.5);
  doc.setFillColor(248, 250, 252);
  doc.roundedRect(qrX, qrY, qrSize, qrSize, 2, 2, 'FD');

  // Draw QR pattern (simplified pixel grid to represent QR code)
  doc.setFillColor(26, 82, 118);
  const qrPx = qrSize / 7;
  const qrPattern = [
    [1,1,1,0,1,1,1],[1,0,1,0,1,0,1],[1,0,1,1,1,0,1],[0,1,0,0,0,1,0],[1,0,1,1,1,0,1],[1,0,1,0,1,0,1],[1,1,1,0,1,1,1],
  ];
  qrPattern.forEach((row, r) => row.forEach((cell, c) => {
    if (cell) doc.rect(qrX + c * qrPx + 0.5, qrY + r * qrPx + 0.5, qrPx - 0.8, qrPx - 0.8, 'F');
  }));
  doc.setFontSize(5);
  doc.setTextColor(26, 82, 118);
  doc.setFont('helvetica', 'normal');
  doc.text('Scan to verify', qrX + qrSize / 2, qrY + qrSize + 3.5, { align: 'center' });

  // ── EMPLOYEE NAME & INFO ────────────────────────────────────────────────────
  const bodyX = 18, bodyY = 48;
  doc.setFontSize(22);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(26, 82, 118);
  doc.text(name || 'Employee Name', bodyX, bodyY);

  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(55, 65, 81);
  doc.text(designation || '', bodyX, bodyY + 8);

  doc.setFontSize(10);
  doc.setTextColor(107, 114, 128);
  doc.text((department ? department + ' Department' : ''), bodyX, bodyY + 14);

  // ── CONTACT INFO ────────────────────────────────────────────────────────────
  const ciY = bodyY + 24;
  doc.setFontSize(9);
  doc.setTextColor(55, 65, 81);
  const contacts = [
    { icon: '\u2022', label: 'Address: ', value: address },
    { icon: '\u2022', label: 'Phone:   ', value: phone },
    ...(email ? [{ icon: '\u2022', label: 'Email:   ', value: email }] : []),
    { icon: '\u2022', label: 'Website: ', value: website },
  ];
  contacts.forEach((c, i) => {
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(26, 82, 118);
    doc.text(c.icon + ' ' + c.label, bodyX, ciY + i * 6);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(55, 65, 81);
    doc.text(c.value, bodyX + 22, ciY + i * 6);
  });

  // ── DIVIDER ─────────────────────────────────────────────────────────────────
  const divY = ciY + contacts.length * 6 + 6;
  doc.setDrawColor(26, 82, 118);
  doc.setLineWidth(1.2);
  doc.line(bodyX, divY, W - bodyX, divY);
  doc.setDrawColor(30, 132, 73);
  doc.setLineWidth(0.6);
  doc.line(bodyX + 40, divY, W - bodyX, divY);

  // ── CONTENT AREA ────────────────────────────────────────────────────────────
  const contentY = divY + 8;
  const contentH = H - contentY - 42;
  doc.setDrawColor(229, 231, 235);
  doc.setLineWidth(0.4);
  doc.setLineDash([3, 2]);
  doc.roundedRect(bodyX, contentY, W - bodyX * 2, contentH, 3, 3);
  doc.setLineDash([]);

  doc.setFontSize(9);
  doc.setTextColor(209, 213, 219);
  doc.setFont('helvetica', 'italic');
  doc.text('[ Official Letter / Communication Content Goes Here ]', W / 2, contentY + contentH / 2, { align: 'center' });

  // ── SIGNATURE ───────────────────────────────────────────────────────────────
  const sigY = contentY + contentH + 10;
  doc.setDrawColor(55, 65, 81);
  doc.setLineWidth(0.5);
  doc.setLineDash([]);
  doc.line(W - 58, sigY, W - bodyX, sigY);
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(107, 114, 128);
  doc.text('Authorized Signatory', W - 50, sigY + 4, { align: 'center' });

  // ── FOOTER ──────────────────────────────────────────────────────────────────
  doc.setFillColor(30, 132, 73);
  doc.rect(0, H - 16, W * 0.5, 16, 'F');
  doc.setFillColor(26, 82, 118);
  doc.rect(W * 0.5, H - 16, W * 0.5, 16, 'F');

  doc.setFontSize(7.5);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(255, 255, 255);
  doc.text(
    'TSE Workspace Office  \u2022  Green City, Sector-10, Lucknow - 226010  \u2022  ' + website,
    W / 2, H - 7, { align: 'center' }
  );

  // Save
  const fname = filename || `TSE_Letterhead_${refNo.replace(/\//g, '-')}.pdf`;
  doc.save(fname);
}
